module.exports = __webpack_public_path__ + "img/bg_loading.9fe63925.png";